import styled from "styled-components";

export const ApplicationScreen = styled.div`
  height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 30%;
  justify-content: space-evenly
`;